/**
 * Поле «Устройств одновременно» формы платформы (лимит параллельных
 * просмотров платного контента). Пустой селект означает «без лимита»
 * (null): FormBuilder не держит null пунктом списка. Вынесено из
 * schemas.tsx, чтобы проверить тестом без импорта всей формы.
 */
export const PARALLEL_PREMIUM_VIEW_LIMIT_FIELD = {
  label: "Устройств одновременно",
  helperText:
    "Пусто: без лимита. Лимит параллельных просмотров платного контента на зрителя с покупкой; сотрудники платформы не ограничены",
  type: "select" as const,
  xs: 12,
  md: 6,
  fullWidth: true,
  options: [1, 2, 3].map((value) => ({ label: String(value), value })),
};

/**
 * Значение для формы из PlatformEdit: возвращается как есть, поэтому
 * нетронутое сохранение отправляет то же значение (3 у старых платформ,
 * его отдаёт резолвер, null у выключенного лимита).
 */
export function parallelLimitEditValue(platform: {
  parallelPremiumViewLimit?: number | null;
}): number | null {
  return platform.parallelPremiumViewLimit ?? null;
}
